<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'attrAdjustAuditList',
})
</script>
<template>
    <a-card :bordered="false">
        <!-- 搜索区 -->
        <div class="search-wrap">
            <a-form>
                <a-row :gutter="48">
                    <a-col :md="6" :sm="24">
                        <a-form-item label="主体名称">
                            <a-input v-model:value="queryParam.nameOrCode" placeholder="请输入主体名称、税号" allow-clear
                                @keyup.enter="handleSearch" />
                        </a-form-item>
                    </a-col>
                    <a-col :md="6" :sm="24">
                        <a-form-item label="属性名称">
                            <a-select v-model:value="queryParam.name" mode="multiple" allow-clear placeholder="请选择">
                                <a-select-option value="fee_standard">收费标准</a-select-option>
                                <a-select-option value="dls_xf_price">续费价格</a-select-option>
                                <a-select-option value="enter_starttime">入驻开始日期</a-select-option>
                                <a-select-option value="enter_endtime">入驻到期日期</a-select-option>
                                <a-select-option value="founding_time">成立日期</a-select-option>
                                <a-select-option value="verify_time">核准日期</a-select-option>
                                <a-select-option value="yifang_name">租赁合同乙方名称</a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :md="6" :sm="24">
                        <a-form-item label="审核状态">
                            <a-select v-model:value="queryParam.status" mode="multiple" allow-clear placeholder="请选择">
                                <a-select-option :value="1">待审核</a-select-option>
                                <a-select-option :value="2">已通过</a-select-option>
                                <a-select-option :value="3">已拒绝</a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :md="6" :sm="24">
                        <a-form-item label="调整理由">
                            <a-input v-model:value="queryParam.remark" placeholder="请输入" allow-clear
                                @keyup.enter="handleSearch" />
                        </a-form-item>
                    </a-col>
                    <a-col :md="12" :sm="24">
                        <a-form-item label="录入系统时间">
                            <a-range-picker :show-time="{ defaultValue: arrayMonent }" :value="rangTime"
                                :format="format" @change="rangTimeChange" style="width: 100%" />
                        </a-form-item>
                    </a-col>
                    <a-col :md="6" :sm="24">
                        <span class="search-btns">
                            <a-button type="primary" @click="handleSearch">查询</a-button>
                            <a-button style="margin-left: 8px" @click="refreshTable">重置</a-button>
                        </span>
                    </a-col>
                </a-row>
            </a-form>
        </div>

        <!-- 表格 -->
        <a-table :columns="columns" :loading="data.loading" :data-source="dataSource" :pagination="pagination"
            @change="onChange" size="middle" class="audit-table"
            :rowClassName="(record) => (record.status === 1 ? 'row-pending' : '')">
            <template #bodyCell="{ column, record, text }">
                <!-- 公司名称 -->
                <template v-if="column.dataIndex === 'name'">
                    <div class="company-block">
                        <div class="company-name">{{ record.full_name }}</div>
                        <div class="company-meta">
                            <span class="meta-item">👤 代理商：{{ record.seller || '--' }}</span>
                        </div>
                        <div class="company-meta">
                            <span class="meta-item">📍 入驻地址：{{ record.full_address || record.registration_address ||
                                '--' }}</span>
                        </div>
                        <a class="detail-link" @click="goCustomerClick(record.full_name)">查看详情</a>
                    </div>
                </template>

                <!-- 调整属性 -->
                <template v-else-if="column.dataIndex === 'detail'">
                    <div class="detail-block">
                        <div class="detail-title">{{ record.name_name }}</div>
                        <div class="detail-row">
                            <span class="detail-label">调整前</span>
                            <a-tag color="green">{{ formatOldValue(record) }}</a-tag>
                        </div>
                        <div class="detail-row">
                            <span class="detail-label">调整后</span>
                            <a-tag color="blue">{{ formatNewValue(record) }}</a-tag>
                        </div>
                        <div class="detail-remark">理由：{{ record.remark || '--' }}</div>
                    </div>
                </template>

                <!-- 审核 -->
                <template v-else-if="column.dataIndex === 'verification'">
                    <div v-if="record.status === 1">
                        <template v-if="record.audit_permission == 1">
                            <a-input v-model:value="record.desc" placeholder="选填：通过或拒绝的理由" allow-clear
                                style="margin-bottom:8px" />
                            <div class="audit-btns">
                                <a-popconfirm title="确定不通过?" @confirm="verificatioChange(record, 2)">
                                    <a-button danger style="flex:1">不通过</a-button>
                                </a-popconfirm>
                                <a-popconfirm title="确定通过?" @confirm="verificatioChange(record, 1)">
                                    <a-button type="primary" style="flex:1">通过</a-button>
                                </a-popconfirm>
                            </div>
                        </template>
                        <a-tag v-else color="processing">待审核</a-tag>
                    </div>
                    <div v-else>
                        <a-tag v-if="record.status === 2" color="success">审核通过</a-tag>
                        <a-tag v-else color="error">审核不通过</a-tag>
                        <div v-if="record.audit_remark" class="audit-remark">理由：{{ record.audit_remark }}</div>
                    </div>
                </template>

                <!-- 相关附件 -->
                <template v-else-if="column.dataIndex === 'annex_url'">
                    <div class="attach-list">
                        <template v-for="(item, index) in record.annex_url" :key="index">
                            <a-image v-if="isImage(item.url)" :width="56" :height="56" :src="imageDomain + item.url"
                                class="attach-img" />
                            <a v-else :href="imageDomain + item.url" target="_blank" class="attach-file">
                                {{ item.name }}
                            </a>
                        </template>
                        <span v-if="!record.annex_url?.length" class="empty">--</span>
                    </div>
                </template>

                <!-- 申请审核人 -->
                <template v-else-if="column.dataIndex === 'submitName'">
                    <span>{{ record.sellerName || '--' }}</span>
                </template>

                <!-- 审核时间 -->
                <template v-else-if="column.dataIndex === 'updated_at'">
                    <template v-if="record.status !== 1">
                        <div class="audit-time-main">
                            <span class="operator">{{ record.operator_admin_info?.nickname || '--' }}</span>
                            <span class="time-text">{{ text }}</span>
                        </div>
                        <div class="time-sub">耗时 {{ calculateTimeDifference(record.created_at, record.updated_at) }}
                        </div>
                    </template>
                    <span v-else class="empty">--</span>
                </template>
            </template>
        </a-table>
    </a-card>
</template>

<script lang="ts" setup name="attrAdjustAuditList">
import { ref, reactive, computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { message } from 'ant-design-vue'
import type { PaginationProps } from 'ant-design-vue'
import dayjs from 'dayjs'
import { useStore } from 'vuex'
import baseService from '@/utils/http/axios'

const router = useRouter()
const $store = useStore()
const imageDomain = computed(() => $store.state.user.image_domain)

const arrayMonent = [dayjs('00:00:00', 'HH:mm:ss'), dayjs('23:59:59', 'HH:mm:ss')]
const format = 'YYYY-MM-DD HH:mm:ss'

const data = reactive({ loading: false })

const columns = [
    { title: '公司名称', dataIndex: 'name', width: '280px' },
    { title: '调整属性', dataIndex: 'detail', width: '240px' },
    { title: '审核', dataIndex: 'verification', width: '240px' },
    { title: '相关附件', dataIndex: 'annex_url', width: '180px' },
    { title: '申请审核人', dataIndex: 'submitName', width: '120px' },
    { title: '申请时间', dataIndex: 'created_at', width: '170px' },
    { title: '审核时间', dataIndex: 'updated_at', width: '200px' }
]

const createDefaultQuery = () => ({
    nameOrCode: '',
    name: [] as string[],
    status: [1] as number[],
    remark: '',
    between_time: null as string | null
})

const queryParam = reactive<any>(createDefaultQuery())
const dataSource = ref<any[]>([])

const pagination = reactive<PaginationProps>({
    pageSize: 10,
    pageSizeOptions: ['10', '20', '40', '50', '60', '200'],
    current: 1,
    total: 0,
    showSizeChanger: true,
    showQuickJumper: true,
    showTotal: (total) => `总数：${total}`
})

onMounted(() => loadData())

// ---------- 工具 ----------
const isImage = (url: string) => /\.(png|jpe?g)$/i.test(url || '')

const formatOldValue = (record: any) => {
    if (record.name === 'fee_standard') {
        return record.old_value == 1 ? '按年收费' : '一次性收费'
    }
    return record.old_value || '--'
}

const formatNewValue = (record: any) => {
    if (record.name === 'fee_standard') {
        return record.new_value == 1 ? '按年收费' : '一次性收费'
    }
    return record.new_value || '--'
}

// ---------- 加载 ----------
const loadData = () => {
    if (data.loading) return
    data.loading = true
    baseService({
        url: '/admin/v1/attrAdjustList',
        method: 'post',
        data: { page: pagination.current, limit: pagination.pageSize, ...queryParam }
    })
        .then((res) => {
            pagination.total = res.data.total_records
            dataSource.value = res.data.list.map((item: any) => ({ ...item, desc: null }))
        })
        .catch((res) => message.error(res.msg || '审核列表查询失败,请联系管理员'))
        .finally(() => (data.loading = false))
}

const handleSearch = () => {
    pagination.current = 1
    loadData()
}

const refreshTable = () => {
    Object.assign(queryParam, createDefaultQuery())
    pagination.current = 1
    loadData()
}

// ---------- 时间选择 ----------
const rangTime = computed(() => {
    if (!queryParam.between_time) return []
    return queryParam.between_time.split(',').map((item: string) => dayjs(item, format))
})

const rangTimeChange = (val: any, str: string[]) => {
    queryParam.between_time = val ? str.join(',') : null
}

const goCustomerClick = (name: string) => {
    router.push({ path: '/customer', query: { customer_name: name } })
}

// ---------- 分页 ----------
const onChange = (val: any) => {
    pagination.pageSize = val.pageSize
    pagination.current = val.current
    loadData()
}

// ---------- 审核 ----------
const verificatioChange = (record: any, type: number) => {
    baseService({
        url: '/admin/v1/attrAdjustAudit',
        method: 'post',
        data: { reason: record.desc, status: type, id: record.id }
    })
        .then(() => {
            message.success('操作成功')
            loadData()
        })
        .catch((res) => message.error(res.msg || '操作失败,请联系管理员'))
}

// ---------- 时间差 ----------
const calculateTimeDifference = (startDate: string, endDate: string) => {
    if (!startDate || !endDate) return '--'
    const duration = dayjs(endDate).diff(dayjs(startDate), 'minute')
    const days = Math.floor(duration / (24 * 60))
    const hours = Math.floor((duration % (24 * 60)) / 60)
    const minutes = duration % 60
    return `${days > 0 ? days + '天' : ''}${hours > 0 ? hours + '小时' : ''}${minutes > 0 ? minutes : 1}分钟`
}
</script>

<style lang="less" scoped>
// ---------- 搜索区 ----------
.search-wrap {
    margin-bottom: 16px;
    padding: 16px 16px 0;
    background: #fafbfc;
    border-radius: 8px;
}

.search-btns {
    display: inline-block;
    margin-bottom: 24px;
    white-space: nowrap;
}

// ---------- 表格 ----------
.audit-table {
    :deep(.ant-table-thead > tr > th) {
        background: #fafafa;
        font-weight: 600;
        color: #262626;
    }

    :deep(.ant-table-tbody > tr.row-pending > td) {
        background: #fffbf0;
    }

    :deep(.ant-table-tbody > tr > td) {
        vertical-align: top;
        padding-top: 12px;
        padding-bottom: 12px;
    }
}

// ---------- 公司信息 ----------
.company-block {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.company-name {
    font-size: 13px;
    font-weight: 600;
    color: #262626;
    word-break: break-all;
}

.company-meta {
    font-size: 12px;
    line-height: 1.5;
}

.meta-item {
    color: #8c8c8c;
    word-break: break-all;
}

.detail-link {
    font-size: 12px;
    margin-top: 2px;
}

// ---------- 调整属性 ----------
.detail-block {
    display: flex;
    flex-direction: column;
    gap: 4px;
    font-size: 12px;
}

.detail-title {
    font-size: 13px;
    font-weight: 600;
    color: #262626;
    margin-bottom: 2px;
}

.detail-row {
    display: flex;
    align-items: center;
    gap: 6px;
}

.detail-label {
    color: #8c8c8c;
    flex-shrink: 0;
    min-width: 48px;
}

.detail-remark {
    color: #8c8c8c;
    margin-top: 2px;
    word-break: break-all;
}

// ---------- 审核 ----------
.audit-btns {
    display: flex;
    gap: 8px;
}

.audit-remark {
    color: #ff4d4f;
    font-size: 12px;
    line-height: 1.5;
    margin-top: 4px;
    padding: 4px 8px;
    background: #fff1f0;
    border-radius: 4px;
    word-break: break-all;
}

// ---------- 附件 ----------
.attach-list {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    align-items: center;
}

.attach-img {
    border-radius: 6px;
    overflow: hidden;
    border: 1px solid #f0f0f0;
    transition: transform 0.2s;

    &:hover {
        transform: scale(1.05);
    }
}

.attach-file {
    display: inline-block;
    padding: 2px 10px;
    background: #f5f5f5;
    border-radius: 4px;
    font-size: 12px;
    color: #1677ff;

    &:hover {
        background: #e6f4ff;
    }
}

// ---------- 审核时间 ----------
.audit-time-main {
    display: flex;
    gap: 6px;
    align-items: baseline;
    flex-wrap: wrap;
    font-size: 12px;
}

.operator {
    color: #1677ff;
    font-weight: 600;
}

.time-text {
    color: #595959;
}

.time-sub {
    font-size: 12px;
    color: #8c8c8c;
    margin-top: 2px;
}

.empty {
    color: #bfbfbf;
}

:deep(.ant-image) {
    margin-right: 0;
    margin-bottom: 0;
}
</style>
